import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {Card, CardBody, CardTitle} from "reactstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";


// components
import MenuForm from "./_form";
import MenuFilters from "./_filters";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import {
    setCategory,
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services & providers
import {menuService} from "../../../jwt/_services";

const MenuList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    useEffect( () => {
        if( filter)
            return

        props.setFilter(path , {
        });

    }, [  ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, menuService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (_page) => {
        let currentIndex = (_page - 1) * pageSize;
        props.setTableParams(path, pageSize, currentIndex, totalSize, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        props.setCategory(path, null);
        ModalFormContainer( MenuForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(MenuForm, { path, data, Form: MenuForm })
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericActions.remove ,
            data : data,
            fbDataBaseId :  '',
            service: menuService
        } );
    };

    const iconFormatter = (cell) => <>
        <span className={cell} />
        {  '   ' + cell}
    </>

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'code',
            text: 'Codigo',
        }, {
            dataField: 'name',
            text: 'Nombre'
        }, {
            dataField: 'url',
            text: 'Componente'
        }, {
            dataField: 'categoryCode',
            text: 'Categoria'
        }, {
            dataField: 'icon',
            text: 'Icono',
            headerStyle: {width: '200px'},
            formatter: iconFormatter
        }, {
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '150px'},
            formatter: (cell, row) => <div className="float-right">
                <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </div>
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <MenuFilters path={path}/>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
    setCategory
})
export default connect(mapStateToProps, mapActionsToProps)(MenuList)